import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  {
    id: 1,
    link: "/dashboard",
    label: "Dashboard",
    icon: "ri-dashboard-2-line",
    class: "",
    extralink: false,
    submitted: false,
    permissions: [-9990],
  },
  {
    id: 2,
    link: "",
    label: "Business Contact",
    icon: "fa fa-users",
    class: "has-arrow",
    extralink: false,
    submitted: false,
    permissions: [-9938, -9937, -9936],
    subItems: [
      {
        id: 3,
        link: "/brokers",
        label: "Broker",
        icon: "fa fa-user-tie",
        class: "",
        extralink: false,
        submitted: false,
        permissions: [-9938],
      },
      {
        id: 4,
        link: "/underwriter",
        label: "Underwriter",
        icon: "fa fa-gavel",
        class: "",
        extralink: false,
        submitted: false,
        permissions: [-9937],
      },
      {
        id: 5,
        link: "/clients",
        label: "Client",
        icon: "fa fa-users",
        class: "",
        extralink: false,
        submitted: false,
        permissions: [-9936],
      },
    ],
  },
  {
    id: 6,
    link: "",
    label: "Technical Processing",
    icon: "fa fa-line-chart",
    class: "has-arrow",
    extralink: false,
    submitted: false,
    permissions: [-9935, -9934, -9933 , -9922],
    subItems: [
      {
        id: 7,
        link: "/invoice-post",
        label: "Invoice Post",
        icon: "fas fa-file-invoice",
        class: "",
        extralink: false,
        submitted: false,
        permissions: [-9935],
      },
      {
        id: 8,
        link: "/case",
        label: "Case",
        icon: "fas fa-scale-balanced",
        class: "",
        extralink: false,
        submitted: false,
        permissions: [-9934],
      },
      {
        id: 9,
        link: "/invoice",
        label: "Invoice",
        icon: "fas fa-receipt",
        class: "",
        extralink: false,
        submitted: false,
        permissions: [-9933],
      },
      {
        id: 10,
        link: "/group-invoices",
        label: "Update Invoices",
        icon: "fas fa-file-invoice",
        class: "",
        extralink: false,
        submitted: false,
        permissions: [-9922],
      },
    ],
  },
  {
    id: 11,
    link: "",
    label: "Banking",
    icon: "fa fa-building-columns",
    class: "has-arrow",
    extralink: false,
    submitted: false,
    permissions: [-9932, -9931, -9930],
    subItems: [
      {
        id: 12,
        label: "Bank Accounts",
        link: "/bank-accounts",
        class: "",
        icon: "fa fa-building-columns",
        extralink: false,
        submitted: false,
        permissions: [-9932],
        parentId: 10,
      },
      {
        id: 13,
        label: "IBA Bank Import",
        link: "/bank-import",
        class: "",
        icon: "fa fa-file-import",
        extralink: false,
        submitted: false,
        permissions: [-9931],
      },
      {
        id: 14,
        link: "/bank-reconciliation",
        label: "Bank Reconciliation",
        icon: "fas fa-money-bill-transfer",
        class: "",
        extralink: false,
        submitted: false,
        permissions: [-9930],
      },
    ],
  },
  {
    id: 15,
    link: "",
    label: "Credit Control",
    icon: "fa fa-money-bill-alt",
    class: "has-arrow",
    extralink: false,
    submitted: false,
    permissions: [-9923,-9926,-9927, -9928, -9929],
    subItems: [
      {
        id: 16,
        link: "/unallocated-cash-bank-account",
        label: "Unallocated Cash",
        icon: "far fa-money-bill-alt",
        class: "",
        extralink: false,
        submitted: false,
        permissions: [-9927],
      },
      {
        id: 17,
        link: "/outstanding-balance",
        label: "Outstanding Balances",
        icon: "fa fa-balance-scale",
        class: "",
        extralink: false,
        submitted: false,
        permissions: [-9923],
      },
      {
        id: 18,
        link: "/holding-account-bank-account",
        label: "Holding Account",
        icon: "far fa-hand-rock",
        extralink: false,
        submitted: false,
        permissions: [-9928],
      },
      {
        id: 19,
        link: "/client-payment",
        label: "Client Payments",
        icon: "fa fa-calculator",
        class: "",
        extralink: false,
        submitted: false,
        permissions: [-9926],
      },
      {
        id: 20,
        link: "/client-account",
        label: "Client Accounts",
        icon: "fas fa-users",
        class: "",
        extralink: false,
        submitted: false,
        permissions: [-9929],
      },
    ],
  },
  {
    id: 21,
    link: "",
    label: "Maintenance",
    icon: "fa fa-cogs",
    class: "has-arrow",
    extralink: false,
    submitted: false,
    permissions: [-9989, -9988],
    subItems: [
      {
        id: 22,
        label: "Templates",
        link: "/templates",
        class: "",
        icon: "fa fa-file",
        extralink: false,
        submitted: false,
        permissions: [-9989],
        parentId: 10,
      },
      {
        id: 23,
        label: "Lookups",
        link: "/lookups",
        class: "",
        icon: "fa fa-folder-open",
        extralink: false,
        submitted: false,
        permissions: [-9988],
        parentId: 10,
      },
    ],
  },
  {
    id: 24,
    link: "",
    label: "Administration",
    icon: "ri-shield-user-line",
    class: "has-arrow",
    extralink: false,
    submitted: false,
    permissions: [-9987, -9986, -9985, -9984, -9981, -9982, -9978, -9979, -9945, 1005],
    subItems: [
      {
        id: 25,
        label: "Users",
        link: "/users",
        class: "",
        icon: "ri-user-line",
        extralink: false,
        submitted: false,
        permissions: [-9987],
        parentId: 14,
      },
      {
        id: 26,
        link: "/login-analysis",
        label: "Login Analysis",
        class: "",
        icon: "ri-bar-chart-horizontal-line",
        extralink: false,
        submitted: false,
        permissions: [-9986],
        subItems: [],
        parentId: 14,
      },
      {
        id: 27,
        link: "/system-settings",
        label: "System Settings",
        class: "",
        icon: "ri-list-settings-line",
        extralink: false,
        submitted: false,
        permissions: [-9985],
        subItems: [],
        parentId: 14,
      },
      {
        id: 28,
        link: "/export-log",
        label: "Export Log",
        class: "",
        icon: "ri-folder-download-line",
        extralink: false,
        submitted: false,
        permissions: [-9984],
        subItems: [],
        parentId: 14,
      },
      {
        id: 29,
        link: "/email",
        label: "Email",
        class: "",
        icon: "ri-mail-line",
        extralink: false,
        submitted: false,
        permissions: [-9981],
        subItems: [],
        parentId: 14,
      },
      {
        id: 30,
        link: "/email-template",
        label: "Email Template",
        class: "",
        icon: "ri-mail-open-line",
        extralink: false,
        submitted: false,
        permissions: [-9982],
        subItems: [],
        parentId: 14,
      },
      {
        id: 31,
        link: "/agreement",
        label: "Agreements",
        class: "",
        icon: "ri-checkbox-line",
        extralink: false,
        submitted: false,
        permissions: [-9978],
        subItems: [],
        parentId: 14,
      },
      {
        id: 32,
        link: "/system-alerts",
        label: "System Alerts",
        class: "",
        icon: "ri-alert-line",
        extralink: false,
        submitted: false,
        permissions: [-9979],
        subItems: [],
        parentId: 14,
      },
      {
        id: 33,
        link: "/system-administration",
        label: "System Administration",
        class: "",
        icon: "ri-tools-fill",
        extralink: false,
        submitted: false,
        permissions: [-9945],
        subItems: [],
        parentId: 14,
      },
      {
        id: 34,
        link: "/invalid-email-log",
        label: "Invalid Email Log",
        class: "",
        icon: "ri-mail-lock-line",
        extralink: false,
        submitted: false,
        permissions: [-9943],
        subItems: [],
        parentId: 14,
      },
      {
        id: 35,
        link: "/safe-ips",
        label: "Safe IP\'s",
        class: "",
        icon: "ri-lock-line",
        extralink: false,
        submitted: false,
        permissions: [-9942],
        subItems: [],
        parentId: 14,
      },
    ],
  },
];
